exports.fast = '130ms'
exports.smooth = '230ms'
exports.slow = '350ms'
exports.gradual = '530ms'
